import { Component, Input } from "@angular/core";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { VisualizationOptionsType } from "@arch/_shared/types/options-visualization";
import {
    CompanyEntity,
    PointEntity,
    SerieEntity,
    VisualizationEntity
} from "@arch/domain/entity";
import { IndicatorValuesComponent } from "../../visualization/indicator-values/indicator-values.component";

@Component({
    selector: "app-metric-kpi",
    imports: [SharedMaterialModule, SharedDsnModule, IndicatorValuesComponent],
    templateUrl: "./metric-kpi.component.html",
    styleUrl: "./metric-kpi.component.scss"
})
export class MetricKpiComponent {
    @Input({ required: true }) visualization: VisualizationEntity;
    @Input({ required: true }) options: VisualizationOptionsType;
    @Input({ required: true }) series: SerieEntity[];
    @Input({ required: true }) points: PointEntity[];
    @Input({ required: true }) company: CompanyEntity;
}

export interface ISpecialMetricKapiComponent {
    series: SerieEntity[];
    points: PointEntity[];
    visualization: VisualizationEntity;
    options: VisualizationOptionsType;
    company?: CompanyEntity;
}
